import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../../components/DropdownApi';
import MultiDropdownApi from '../../../components/MultiDropdownApi';
import { siteEmployeeAdd, siteEmployeeUpdate } from '../../../service/siteService';
import { PPEEmployeeAdd } from '../../../service/ppeService';
import { FormControl, Grid } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import useApiService from '../../../hooks/useApiService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Avatar } from 'primereact/avatar';
import { InputText } from 'primereact/inputtext';

export default function EmployeePPEAdd(modalProps: any) {

  const employee = modalProps.employee;

  const [records, setRecords] = useState<any[]>([]);
  const [selectedRecords, setSelectedRecords] = useState<any[] | null>(null);
  const [selectedData, setSelectedData] = useState<any[]>([]);
  const [rowClick, __] = useState(true);

  const { loading } = useApiService<any[]>({
    url: "ppe",
    method: "GET",
    apiName: "core",
    onSuccess: data => {
      setRecords(data);
    },
  });

  function handleSelectionChange(e: any) {
    console.log("e == ", e);
    setSelectedRecords(e.value);
  }

  function handleSizeChange(value: string, recordId: any) {
    setRecords(prev => prev.map(record =>
      record.id === recordId ? { ...record, size: value } : record
    ));
    setSelectedRecords(prev => prev ? prev.map(record =>
      record.id === recordId ? { ...record, size: value } : record
    ) : null);
  }

  useEffect(() => {
    if (selectedRecords) {
      const selectedWithSizes = selectedRecords.map((record: any) => ({
        id: record.id,
        size: record.size || ''
      }));
      setSelectedData(selectedWithSizes);
    }
  }, [selectedRecords]);

  async function PPEAdd() {
    console.log("selectedData == ", selectedData);
    await Promise.all(
      selectedData.map(async (item: any) => {
        const data = {
          employee,
          ppe: item.id,
          size: item.size,
        };
        return await PPEEmployeeAdd(data);
      }
      )).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({ severity: 'success', summary: 'PPE Added Successfully', life: 3000 });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      });
  }

  const displayPhoto = (data: any) => {
    return (
      <Stack direction="row" spacing={2}>
        <FormControl style={{ margin: "auto" }}>
          <Avatar image={data.photo} size="normal" shape="circle" />
        </FormControl>
      </Stack>
    );
  };

  const sizeEditor = (data: any) => {
    return (
      <InputText
        value={data.size || ''}
        onChange={(e) => handleSizeChange(e.target.value, data.id)}
        placeholder="Enter size"
        style={{ width: '100px' }}
      />
    );
  };

  return (
    <Fragment>
      <DataTable
        value={records}
        selectionMode={rowClick ? "multiple" : null}
        selection={selectedRecords || []}
        onSelectionChange={(e: any) => {
          handleSelectionChange(e);
        }}
        dataKey={"id"}
        tableStyle={{ minWidth: "50rem" }}
        loading={loading}
      >
        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
        <Column field={"photo"} header={"Image"} body={displayPhoto} />
        <Column field={"name"} header={"Name"} />
        <Column field={"size"} header={"Size"} body={sizeEditor} />
      </DataTable>
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => PPEAdd()} />
        </CardActions>
      </CardOverflow>
    </Fragment>
  );
}